module.exports = __webpack_public_path__ + "img/verify.2bab04f9.svg";